import React, { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Moment from 'moment';
import { string } from 'prop-types';
import CheckIcon from '@material-ui/icons/Check';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  Divider,
  LinearProgress,
  MenuItem,
  Table,
  TableBody,
  TableHead,
  TableRow,
  FormControl,
  InputLabel,
  Select,
} from '@material-ui/core';
import InsertInvitationRoundedIcon from '@material-ui/icons/InsertInvitationRounded';
import { storeContext } from '../provider/Provider';
import {
  StyledContentTableCell,
  StyledContentTableHeadCell,
  StyledContentTableHeadCell2,
  StyledTableCell,
  StyledTablePagination,
} from '../../customUI/table/TableStyles';
import MobileTitle from '../../customUI/MobileTitle';
import useStyles from './PaidMediaFullView.style';
import MobilePpcCard from './MobilePpcCard';
import { ppcActions } from '../../store/ppc-reducer';

const { REACT_APP_FLASK_API_URL } = process.env;

const PaidMediaFullView = (props) => {
  const { type = 'campaigns' } = props;
  const history = useHistory();

  const classes = useStyles();
  const { state, dispatch } = React.useContext(storeContext);
  let isPhone = false;
  if (!state.websiteAnalytics.isTesting) {
    isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  }
  const [mobileDate, setMobileDate] = React.useState(false);
  const [isInternalFetching, setIsInternalFetching] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [perPage, setPerPage] = React.useState(15);

  const initStartDate = new Moment().subtract(1, 'months').date(1);
  const initEndDate = new Moment().date(0);

  const [dateFrom, setDateFrom] = React.useState(initStartDate.format('YYYY-MM-DD'));
  const [dateTo, setDateTo] = React.useState(initEndDate.format('YYYY-MM-DD'));

  const [dateFromOptions, setDateFromOptions] = React.useState([
    {
      value: initStartDate.format('YYYY-MM-DD'),
      label: initStartDate.format('MMMM YYYY'),
    },
  ]);
  const [dateToOptions, setDateToOptions] = React.useState([
    {
      value: initEndDate.format('YYYY-MM-DD'),
      label: initEndDate.format('MMMM YYYY'),
    },
  ]);

  const updateRows = (pageUp, perPageUp) => {
    if (dateTo < dateFrom) {
      const dateToMod = new Moment(dateFrom).add(1, 'months').date(0).format('YYYY-MM-DD');
      return setDateTo(dateToMod);
    }

    setIsInternalFetching(true);
    const requestUrl = `${REACT_APP_FLASK_API_URL}/v1/ppc-stats-campaigns/${state.websiteSwitch.currentWebsite}/${pageUp}/${perPageUp}/${dateFrom}/${dateTo}`;

    return axios.get(requestUrl).then((res) => {
      dispatch({
        type: ppcActions.PPC_SET_CAMPAIGNS,
        payload: {
          campaigns: res.data.data.by_campaign_stats,
          campaigns_total: res.data.data.by_campaign_stats_total_count,
          locations: res.data.data.by_location_stats,
          locations_total: res.data.data.by_location_stats_total_count,
          isFetching: false,
        },
      });

      setDateFromOptions(
        res.data.data.months.map((monthYear) => ({
          value: new Moment(monthYear).format('YYYY-MM-DD'),
          label: monthYear,
        }))
      );

      setDateToOptions(
        res.data.data.months.map((monthYear) => ({
          value: new Moment(monthYear).add(1, 'months').date(0).format('YYYY-MM-DD'),
          label: monthYear,
        }))
      );

      return setIsInternalFetching(false);
    });
  };

  useEffect(() => {
    setPage(0);
    updateRows(1, perPage);
  }, [dateFrom, dateTo]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    updateRows(newPage + 1, perPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPerPage(parseInt(event.target.value, 10));
    updateRows(1, parseInt(event.target.value, 10));
  };

  const handleOpenDate = () => {
    setMobileDate(true);
  };

  // function getDate(dateStr) {
  //   let date = new Date(dateStr);
  //   date = new Date(date.getFullYear(), date.getMonth() - 1, 1);
  //   return `${date.toLocaleString('en-US', { month: 'short' })} ${date.getFullYear()}`;
  // }

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  });

  if (isInternalFetching) {
    return (
      <LinearProgress
        style={{ width: '100%' }}
        classes={{
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
        }}
      />
    );
  }

  if (isPhone) {
    return (
      <>
        <MobileTitle title="Paid Media Results" />
        <div className={classes.flex__container} id="mobileHeader">
          <div className={classes.routeButtonsWrapMobile}>
            <Button
              disabled={type === 'campaigns'}
              onClick={() => {
                history.push('/paid-media/full-view/campaigns');
              }}
            >
              Campaign <CheckIcon fontSize="small" />
            </Button>
            <Button
              disabled={type === 'locations'}
              onClick={() => {
                history.push('/paid-media/full-view/locations');
              }}
            >
              Location <CheckIcon fontSize="small" />
            </Button>
          </div>

          <p className={classes.fullViewIcons}>
            <InsertInvitationRoundedIcon onClick={handleOpenDate} />
          </p>
          <Dialog
            open={mobileDate}
            className={classes.datePopup}
            onClose={() => {
              setMobileDate(false);
            }}
          >
            <DialogTitle id="form-dialog-title">
              Please select the dates to filter the pages.
            </DialogTitle>
            <div className={classes.dateInputFlex}>
              <div className={classes.pickerWrapper}>
                <FormControl variant="outlined">
                  <InputLabel>Start</InputLabel>
                  <Select
                    value={dateFrom}
                    onChange={(from) => setDateFrom(from.target.value)}
                    label="Start"
                    aria-label="select Start"
                  >
                    {dateFromOptions.map((dateFromOption) => (
                      <MenuItem value={dateFromOption.value} key={dateFromOption.value}>
                        {dateFromOption.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className={classes.pickerWrapper}>
                <FormControl variant="outlined">
                  <InputLabel>End</InputLabel>
                  <Select
                    value={dateTo}
                    onChange={(to) => setDateTo(to.target.value)}
                    label="End"
                    aria-label="select End date"
                  >
                    {dateToOptions.map((dateToOption) => (
                      <MenuItem value={dateToOption.value} key={dateToOption.value}>
                        {dateToOption.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </Dialog>
        </div>
        {state.ppc[`${type}_total`] !== 0 ? (
          state.ppc[type] &&
          Object.entries(state.ppc[type]).map(([key, value]) => (
            <MobilePpcCard date="" name={`${key}`} metrics={value} />
          ))
        ) : (
          <>
            <div style={{ margin: '5% 0 0 5%' }}>No results</div>
          </>
        )}
        {isInternalFetching && (
          <div className={classes.loading} style={{ height: 400 }}>
            <CircularProgress />
          </div>
        )}
        <StyledTablePagination
          rowsPerPageOptions={[15, 50]}
          component="div"
          count={state.ppc[`${type}_total`]}
          rowsPerPage={perPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Rows:"
        />
      </>
    );
  }

  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.card}>
          <div className={classes.card__wrapper}>
            <div className={classes.card__header}>
              <div className={classes.heading}>
                Paid Media Results
                <div className={classes.routeButtonsWrap}>
                  <Button
                    disabled={type === 'campaigns'}
                    onClick={() => {
                      history.push('/paid-media/full-view/campaigns');
                    }}
                  >
                    Campaign <CheckIcon fontSize="small" />
                  </Button>
                  <Button
                    disabled={type === 'locations'}
                    onClick={() => {
                      history.push('/paid-media/full-view/locations');
                    }}
                  >
                    Location <CheckIcon fontSize="small" />
                  </Button>
                </div>
              </div>
              <div className={classes.searchInputFlex}>
                <div className={classes.pickerWrapper}>
                  <FormControl variant="outlined">
                    <InputLabel>Start</InputLabel>
                    <Select
                      value={dateFrom}
                      onChange={(from) => setDateFrom(from.target.value)}
                      label="Start"
                      aria-label="select Start"
                    >
                      {dateFromOptions.map((dateFromOption) => (
                        <MenuItem value={dateFromOption.value} key={dateFromOption.value}>
                          {dateFromOption.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className={classes.pickerWrapper}>
                  <FormControl variant="outlined">
                    <InputLabel>End</InputLabel>
                    <Select
                      value={dateTo}
                      onChange={(to) => setDateTo(to.target.value)}
                      label="End"
                      aria-label="select End date"
                    >
                      {dateToOptions.map((dateToOption) => (
                        <MenuItem value={dateToOption.value} key={dateToOption.value}>
                          {dateToOption.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledContentTableHeadCell>Name</StyledContentTableHeadCell>
                  <StyledContentTableHeadCell>Cost</StyledContentTableHeadCell>
                  <StyledContentTableHeadCell>Total Conversions</StyledContentTableHeadCell>
                  <StyledContentTableHeadCell>
                    Conversions From Interactions Rate
                  </StyledContentTableHeadCell>
                  <StyledContentTableHeadCell>Cost/Conversions</StyledContentTableHeadCell>
                  <StyledContentTableHeadCell>Impressions</StyledContentTableHeadCell>
                  <StyledContentTableHeadCell>Clicks</StyledContentTableHeadCell>
                  <StyledContentTableHeadCell2>Search Impression Share</StyledContentTableHeadCell2>
                </TableRow>
              </TableHead>
              {!isInternalFetching && (
                <TableBody id="tableBody">
                  {Object.keys(state.ppc[type]).length ? (
                    Object.entries(state.ppc[type]).map((arr) => (
                      <TableRow key={arr[0]}>
                        <StyledTableCell>{arr[0]}</StyledTableCell>
                        <StyledTableCell>
                          {currencyFormatter.format(
                            Number(arr[1]['metrics.cost_micros']).toFixed(2)
                          )}
                        </StyledTableCell>
                        <StyledTableCell>
                          {+Number(arr[1]['metrics.conversions']).toFixed(2)}
                        </StyledTableCell>
                        <StyledTableCell>
                          {arr[1]['metrics.conversions_from_interactions_rate']
                            ? +Number(arr[1]['metrics.conversions_from_interactions_rate']).toFixed(
                                2
                              )
                            : '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {currencyFormatter.format(
                            Number(arr[1]['metrics.cost_per_conversions']).toFixed(2)
                          )}
                        </StyledTableCell>
                        <StyledTableCell>{arr[1]['metrics.impressions']}</StyledTableCell>
                        <StyledTableCell>{arr[1]['metrics.clicks']}</StyledTableCell>
                        <StyledTableCell>
                          {arr[1]['metrics.search_impression_share']
                            ? `${+Number(arr[1]['metrics.search_impression_share'] * 100).toFixed(
                                2
                              )}%`
                            : '-'}
                        </StyledTableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <StyledContentTableCell>No results</StyledContentTableCell>
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
          </div>
          <Divider />

          <div className={classes.card__wrapper}>
            <div className={classes.cardActionButton} aria-hidden="true">
              <StyledTablePagination
                rowsPerPageOptions={[15, 50]}
                component="div"
                count={state.ppc[`${type}_total`]}
                rowsPerPage={perPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

PaidMediaFullView.propTypes = {
  type: string,
};

PaidMediaFullView.defaultProps = {
  type: 'campaigns',
};

export default PaidMediaFullView;
